import * as q from 'q';
import * as globalConfig from 'globalConfig';

import { Language } from "Content/ts/Models/Shared/Language/Language";

export class LanguageService {
    getLanguages(): q.Promise<Language[]> {
        return q($.ajax({ url: globalConfig.Urls.Languages.RetrieveAvailableLanguages, type: 'GET' }));
    }

    setLanguage(languageId: number): q.Promise<boolean> {
        return q($.ajax({
            url: globalConfig.Urls.Languages.SetLanguage.replace('{langId}', languageId.toString()),
            type: 'PUT'
        }));
    }
}